import type { Directive, DirectiveBinding } from 'vue'

const OVERFLOW_ATTR = 'data-overflow-tooltip-bound'

const syncTitle = (el: HTMLElement) => {
  const isOverflowing = el.scrollWidth > el.clientWidth + 1
  if (isOverflowing) {
    const text = (el.textContent || '').trim()
    if (text) {
      el.setAttribute('title', text)
      return
    }
  }
  el.removeAttribute('title')
}

const bind = (el: HTMLElement) => {
  if (el.getAttribute(OVERFLOW_ATTR) === '1') return
  el.setAttribute(OVERFLOW_ATTR, '1')
  el.addEventListener('mouseenter', () => syncTitle(el))
}

export const vOverflowTooltip: Directive<HTMLElement> = {
  mounted(el: HTMLElement, _binding: DirectiveBinding) {
    bind(el)
  },
  updated(el: HTMLElement) {
    bind(el)
    if (el.hasAttribute('title')) syncTitle(el)
  },
}

export default vOverflowTooltip
